import { Component, Input, Output, EventEmitter } from "@angular/core";
import {
  AngularFireStorage,
  AngularFireUploadTask
} from "angularfire2/storage";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { Camera } from "@ionic-native/camera";
import {
  Platform,
  ActionSheetController,
  LoadingController,
  AlertController
} from "ionic-angular";
import { ImageProvider } from "../../providers/image/image";
import { Observable } from 'rxjs/Observable';

@Component({
  selector: "upload-insurance",
  templateUrl: "upload-insurance.html"
})
export class UploadInsuranceComponent {
  @Input()
  existingImageUrl: any;
  @Input()
  existingImageType: any;
  @Input()
  clinic_name: any;
  @Input()
  doctor: any = {};
  @Input()
  patient: any = {};
  @Output()
  getInsuranceUrl = new EventEmitter<Object>();

  task: AngularFireUploadTask;

  progress: any; // Observable 0 to 100
  complete: any;
  ismobile: boolean;
  imageUrl: string; // base64
  pdfUrl: string;
  downloadUrl: string;
  image_type: string = "insurance";

  snapshot: Observable<any>;
  isHovering: boolean;

  constructor(
    public storage: AngularFireStorage,
    private camera: Camera,
    private platform: Platform,
    private iab: InAppBrowser,
    private actionSheetCtrl: ActionSheetController,
    private image: ImageProvider,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController
  ) {
    console.log("Patient Data - Insurance Upload: ", this.patient);
  }

  ngOnInit() {
    if (this.platform.is("ios") || this.platform.is("android")) {
      this.ismobile = true;
    }

    if (this.existingImageType === "pdf") {
      if (this.existingImageUrl) this.pdfUrl = this.existingImageUrl;
    } else {
      if (this.existingImageUrl) this.imageUrl = this.existingImageUrl;
    }
  }

  async captureImage(sourceType) {
    const options = {
      quality: 50,
      encodingType: 0,
      destinationType: 0,
      targetWidth: 1024,
      targetHeight: 1024,
      correctOrientation: true,
      allowEdit: false,
      sourceType: sourceType
    };
    return await this.camera.getPicture(options);
  }

  createUploadTask(file: string, type: string): void {
    let filePath: any = null;
    filePath = `${this.image_type}/${
      this.clinic_name
    }_${new Date().getTime()}.${type}`;

    console.log("File Path: ", filePath);
    this.task = this.storage.ref(filePath).putString(file, "data_url");

    this.task.then(t => {
      t.ref.getDownloadURL().then(u => {
        this.downloadUrl = u;
        if (type === "pdf") {
          this.pdfUrl = this.downloadUrl;
          this.imageUrl = null;
        } else {
          this.pdfUrl = null;
          this.imageUrl = this.downloadUrl;
        }
        let file: any = {};
        file.url = this.downloadUrl;
        file.type = type;
        this.getInsuranceUrl.emit(file);
        console.log("File Upload Complete: ", file);
      });
    });
    this.snapshot   = this.task.snapshotChanges();
    this.progress = this.task.percentageChanges();
  }

    // Determines if the upload task is active
    isActive(snapshot) {
      return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes
    }

    toggleHover(event: boolean) {
      this.isHovering = event;
    }

  public presentActionSheet() {
    let actionSheet = this.actionSheetCtrl.create({
      title: "Select Image Source",
      buttons: [
        {
          text: "Load from Photo Library",
          handler: () => {
            this.uploadHandler(this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        },
        {
          text: "Use Camera",
          handler: () => {
            this.uploadHandler(this.camera.PictureSourceType.CAMERA);
          }
        },
        {
          text: "Cancel",
          role: "cancel"
        }
      ]
    });
    actionSheet.present();
  }

  async uploadHandler(sourceType) {
    console.log("Upload Patient: ", this.patient);
    console.log("Upload Doctor: ", this.doctor);
    const imagestring = await this.captureImage(sourceType);
    const loading = this.loadingCtrl.create({
      content: "Processing Image"
    });
    loading.present();
    const base64 = "data:image/jpeg;base64," + imagestring;
    console.log("Image Captured: ", base64);
    var date = new Date();
    let imageText = this.clinic_name;
    if (this.patient)
      imageText +=
        " - " + this.patient.first_name + " " + this.patient.last_name + " - ";
    else imageText += " - ";
    imageText += date.toLocaleDateString() + " " + date.toLocaleTimeString();

    this.image.addTextToImage(base64, imageText).then(img => {
      console.log(imageText);
      console.log(img);
      loading.dismiss().then(() => {
        this.createUploadTask(img, "jpg");
      });
    });
  }

  public uploadInsurance(files: FileList) {
    // Client-side validation example
    if (files.length > 1 ) { 
      let alert = this.alertCtrl.create({
        title: "File  Problem",
        subTitle: "You may only upload one insurance image",
        buttons: ["OK"]
      });
      alert.present();
      return;
    }
    let filetype: any = files.item(0).type.split('/')[1].replace(' ','');
    console.log(filetype);
    if (filetype !== 'jpg' && filetype !== 'jpeg' && filetype !== 'pdf' ) { 
      let alert = this.alertCtrl.create({
        title: "File Type Problem",
        subTitle: "Please only upload image or pdf files",
        buttons: ["OK"]
      });
      alert.present();
      return;
    }
    const loading = this.loadingCtrl.create({
      content: "Processing Image"
    });
    loading.present();
    this.image.getBase64(files.item(0)).then((b64Image: string) => {
      console.log(b64Image);
      if (files.item(0).type === "application/pdf") {
        loading.dismiss().then(() => {
          this.createUploadTask(b64Image, "pdf");
        });
      } else {
        var date = new Date();
        let imageText = this.clinic_name;
        if (this.patient.first_name !== null || this.patient.last_name !== null || this.patient.first_name !== 'undefined' || this.patient.last_name !== 'undefined' )
          imageText +=
            " - " +
            this.patient.first_name +
            " " +
            this.patient.last_name +
            " - ";
        else imageText += " - ";
        imageText +=
          date.toLocaleDateString() + " " + date.toLocaleTimeString();
        console.log("Add Text: ", imageText);
        this.image.addTextToImage(b64Image, imageText).then(img => {
          loading.dismiss().then(() => {
            this.createUploadTask(img, "jpg");
          });
        });
      }
    });
  }

  openPDF(url) {
    this.iab.create(url, "_blank");
  }
}



// WEBPACK FOOTER //
// ./src/components/upload-insurance/upload-insurance.ts